import brand from '@helpers/brand';
import { DatePickerCss } from '@helpers/dateRangeStyles';
import { fonts } from '@helpers/fonts';
import { ButtonStyles } from '@stories/Components/Buttons/Button/Button.styles';
import styled from 'styled-components';
import { InputStyles } from '../Textbox/Textbox.styles';
import { ThemeSwitch } from '@helpers/theme';
const Wrapper = styled.div `
  ${ButtonStyles.Button} {
    align-self: center;
  }

  ${DatePickerCss};

  .react-datepicker__tab-loop {
    display: contents;
  }

  .react-datepicker-wrapper {
    grid-column: span 2;

    input {
      ${InputStyles};
      width: 100%;
    }
  }

  .react-datepicker__tab-loop__start,
  .react-datepicker__tab-loop__end {
    display: none;
  }

  .react-datepicker__day--in-range,
  .react-datepicker__day--in-range:hover {
    ${ThemeSwitch({ groundforceColour: brand.primary.base })};
    background-color: var(--theme);
  }

  .react-datepicker__day--in-selecting-range {
    ${ThemeSwitch({ generateOpacity: true })};
    background-color: var(--theme-half-opacity) !important;
  }

  .react-datepicker__current-month {
    font-size: 12px;
  }

  .react-datepicker__triangle {
    margin-left: -20px !important;
  }

  .react-datepicker__day {
    margin: 4px;
    font-size: 11px;
    width: 26px;
    line-height: 22px;
  }

  .react-datepicker__day-name {
    margin: 4px;
    font-size: 11px;
    width: 26px;
  }
`;
const LabelText = styled.div `
  ${fonts.DaxPro['Medium']};
  font-size: 18px;
  color: ${brand.grey.grey20};
  margin-bottom: 6px;
`;
export default {
    Wrapper,
    LabelText,
};
